var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('modals.additionalContact.updateTitle'),"action":"update","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('contact-person-form',{attrs:{"contact-person":_vm.contact}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }